module.exports = __webpack_public_path__ + "img/8.29fd777d.gif";